/** @jsxImportSource @emotion/react */
import { TableRowHeader } from "../../../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../../../components/table-components/TableCellHeaderText";
import { firstTableCellStyle } from "../../../../style-util";

export const CtasListHeader = () => {
  return (
    <thead>
      <TableRowHeader>
        <TableCellHeaderText css={firstTableCellStyle}>
          Image
        </TableCellHeaderText>
        <TableCellHeaderText>Title</TableCellHeaderText>
        <TableCellHeaderText>Country code</TableCellHeaderText>
        <TableCellHeaderText>Locale</TableCellHeaderText>
        <TableCellHeaderText>Type</TableCellHeaderText>
        <th />
      </TableRowHeader>
    </thead>
  );
};
